import React from 'react';
import update from 'immutability-helper';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import EntityCollectionField from '../../../contentful/EntityCollectionField';
import AssetField from '../../../contentful/AssetField';

class OpenGraphComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleMetadataChange = this.handleMetadataChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      opengraph: {}
    };

    change.opengraph[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleMetadataChange(e) {
    const metadata = this.props.opengraph.metadata || {};
    metadata[e.target.name] = e.target.value;
    return this.handleAssetChange('metadata', metadata);
  }

  handleFieldChange(e) {
    return this.handleAssetChange(e.target.name, e.target.value);
  }

  render() {
    const opengraph = this.props.opengraph;
    const metadata = opengraph.metadata || {};

    const targetName = this.props.newTypeData.title || this.props.newTypeData.name || (opengraph.target && (opengraph.target.title || opengraph.target.name));

    return (
      <section className="mf-equipment-equipment">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          {this.props.type === 'article' && <>
            <li><Link to="/articles">Artikler</Link></li>
            <li><Link to={`/articles/${this.props.newTypeData.id || opengraph.target.id}`}>{targetName}</Link></li>
          </>}
          {this.props.type === 'campaign' && <>
            <li><Link to="/campaigns">Kampanjer</Link></li>
            <li><Link to={`/campaigns/${this.props.newTypeData.id || opengraph.target.id}`}>{targetName}</Link></li>
          </>}
          {this.props.type === 'model' && <>
            <li><Link to="/nybilinformasjon">Nybilinformasjon</Link></li>
            {opengraph.make.name && <li><Link to={`/modeller/${opengraph.make.id}`}>{opengraph.make.name}/</Link></li>}
            <li><Link to={`/modeller/${opengraph.make.id}/modell/${this.props.newTypeData.id || opengraph.target.id}`}>{targetName}/</Link></li>
          </>}
          {(!this.props.type || (this.props.type === 'make')) && <>
            <li><Link to="/merker">Merke</Link></li>
            <li><Link to={`/merker/${this.props.newTypeData?.id || opengraph.make?.id}`}>{this.props.newTypeData?.name || opengraph.make?.name}</Link></li>
          </>}
          {
          // <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
          // <li>
          //   <Link to={`/modeller/${opengraph.model.make.id}`}>{opengraph.model.make.name}</Link>
          // </li>
          // <li>
          //   <Link to={`/modeller/${opengraph.model.make.id}/modell/${opengraph.model.id}`}>{opengraph.model.name}</Link>
          // </li>
          }
          <li className="active">{opengraph.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {opengraph.name} <PublishStatusDot entry={opengraph} /><br/>
                  <small>OpenGraph</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!opengraph.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>
                      {Boolean(opengraph.id) &&
                          <span>Lagre</span>
                      }
                      {!opengraph.id &&
                          <span>Opprett</span>
                      }
                    </span>
                  </button>
                }
                &nbsp;
                {opengraph.id && <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={!(opengraph.draft || opengraph.updated) || this.props.working || this.props.modified || opengraph.archived}
                    onClick={this.handlePublish}
                  >
                    <span>Publiser</span>
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-warning"
                    disabled={opengraph.draft || this.props.working || this.props.modified}
                    onClick={this.handleUnpublish}
                  >
                    <span>Avpubliser</span>
                  </button>
                  &nbsp;
                  {!opengraph.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={this.props.working}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onArchive();
                      }}
                    >
                      <span>Arkiver</span>
                    </button>
                  }
                  &nbsp;
                  {opengraph.archived &&
                    <button
                      type="button"
                      className="btn btn-danger"
                      disabled={this.props.working}
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.onUnarchive();
                      }}
                    >
                      <span>Gjenopprett</span>
                    </button>
                  }
                </React.Fragment>}
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Navn</label>
                <input type="text" className="form-control" name="name" disabled={this.props.working || opengraph.archived} defaultValue={opengraph.name} onChange={this.handleFieldChange} required />
              </div>
              {!opengraph.target && <div className="form-group">
                <label>Side</label>
                {/*<input type="text" className="form-control" name="url" disabled={this.props.working || opengraph.archived} defaultValue={opengraph.url} onChange={this.handleFieldChange} />*/}
                <select
                  type="text"
                  className="form-control"
                  name="url"
                  defaultValue={opengraph.url}
                  onChange={this.handleFieldChange}
                  disabled={this.props.working || opengraph.archived}
                >
                  <option value="">Alle</option>
                  <option value=".">Forsiden</option>
                  {opengraph.url && opengraph.url !== '.' &&
                    <option value={opengraph.url}>{opengraph.url}</option>
                  }
                </select>
              </div>}
              {opengraph.target && this.props.type === 'model' && <div className="form-group">
                <label>Underside</label>
                {/*<input type="text" className="form-control" name="url" disabled={this.props.working || opengraph.archived} defaultValue={opengraph.url} onChange={this.handleFieldChange} />*/}
                <select
                  type="text"
                  className="form-control"
                  name="url"
                  defaultValue={opengraph.url}
                  onChange={this.handleFieldChange}
                  disabled={this.props.working || opengraph.archived}
                >
                  <option value="">Alle</option>
                  <option value="be-om-tilbud">Konfigurator</option>
                  <option value="provekjor">Prøvekjør</option>
                  <option value="brosjyre">Brosjyre</option>
                </select>
              </div>}
              {opengraph.target && !this.props.type && opengraph.url && <div className="form-group">
                <label>Underside url</label>
                <input type="text" className="form-control" disabled value={opengraph.url} />
              </div>}
              {!opengraph.target && <div className="form-group">
                <label>Type</label>
                <select
                  type="text"
                  className="form-control"
                  name="mode"
                  defaultValue={opengraph.mode}
                  onChange={this.handleFieldChange}
                  disabled={!opengraph.modes || this.props.working || opengraph.archived}
                >
                  {!opengraph.modes && <option value="" selected>Du må lagre før du kan velge</option>}
                  <option value="">Ingen begrensning</option>
                  {opengraph.modes && opengraph.modes.map((mode) => <option key={`mode-${mode}`} value={mode}>{mode}</option>)}
                </select>
              </div>}
              <section className="panel panel-info">
                <div className="panel-heading" role="tab" id="heading-details">
                  <strong><i className="fa fa-info"/> Metadata</strong>
                </div>
                <div className="panel-body">
                  <div className="form-group">
                    <label>Tittel (sidetittel)</label>
                    <input type="text" className="form-control" name="title" onChange={this.handleMetadataChange} defaultValue={metadata.title}/>
                  </div>
                  <div className="form-group">
                    <label>Opengraph - Tittel</label>
                    <input type="text" className="form-control" name="og:title" onChange={this.handleMetadataChange} defaultValue={metadata['og:title']} />
                  </div>
                  <div className="form-group">
                    <label>Opengraph - Beskrivelse</label>
                    <textarea rows="2" className="form-control" name="og:description" onChange={this.handleMetadataChange} defaultValue={metadata['og:description']}></textarea>
                  </div>
                  <div className="form-group">
                    <label>Meta - Beskrivelse</label>
                    <textarea rows="2" className="form-control" name="description" onChange={this.handleMetadataChange} defaultValue={metadata.description}></textarea>
                    <span className="help-block">Brukes ikke av SoMe. Men kan bli brukt ved visning av søkeresultater på f.eks google</span>
                  </div>
                </div>
              </section>
              <div className="form-group">
                <label>Opengraph - Bilde</label>
                <AssetField name="image" value={opengraph.image} onChange={this.handleAssetChange} disabled={this.props.working} />
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              {!opengraph.target && <div className="form-group">
                <label>Prioritet</label>
                <input type="number" step="1" className="form-control" name="priority" defaultValue={opengraph.priority} disabled={this.props.working || opengraph.archived} onChange={this.handleFieldChange} />
              </div>}
              {!opengraph.target && <div className="form-group">
                <div className="checkbox">
                  <label>
                    <input type="checkbox" name="motorforumOnly" defaultChecked={opengraph.motorforumOnly} onChange={this.handleFieldChange} disabled={this.props.working || opengraph.archived} />
                    <strong>Gjelder kun på motorforum</strong>
                  </label>
                </div>
              </div>}
              <div className="form-group">
                <label>Begrens til forhandlere</label>
                <EntityCollectionField
                  name="dealers"
                  value={opengraph.dealers}
                  contentType="forhandler"
                  removeAllButton={true}
                  quickAdd={true}
                  onChange={this.handleAssetChange}
                  disabled={this.props.working || opengraph.archived }
                />
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default OpenGraphComponent;
